import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=230aef26"
import script from "./ContactDetails.vue?vue&type=script&lang=ts"
export * from "./ContactDetails.vue?vue&type=script&lang=ts"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=230aef26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports